import { AUTO_CAPTION_ENGINES } from "@constants";

/**
 * 자동 자막 엔진별 options payload를 조립한다.
 * 자산 분석 경로(useAiAnalysis)와 이벤트 트리거 경로(createEventTrigger)가 공유한다. [DAM-556]
 * shouldTranscodeFirst는 자산 크기 기반이라 자산 경로에서만 의미가 있으므로 호출자가 얹는다.
 * @param {string} serviceType - AUTO_CAPTION_ENGINES 값 (AWS_TRANSCRIBE | DAGLO_STT | SUBSY_STT)
 * @param {object} params - 자막 설정 상태 (languageCode, identifyLanguage, ...)
 * @returns {object|null} 엔진별 options 객체, 미지원 엔진이면 null
 */
const buildAutoCaptionOptions = (serviceType, params) => {
    const { identifyLanguage, identifyMultipleLanguages, languageOptions, speakerDiarization, languageCode, dictationVocabularyId } = params;

    switch (serviceType) {
        case AUTO_CAPTION_ENGINES.AWS_TRANSCRIBE:
            return {
                identifyLanguage,
                identifyMultipleLanguages,
                ...(identifyMultipleLanguages && { languageOptions }),
                languageCode,
                dictationVocabularyId,
            };
        case AUTO_CAPTION_ENGINES.DAGLO_STT:
            return { languageCode, dictationVocabularyId, speakerDiarization };
        case AUTO_CAPTION_ENGINES.SUBSY_STT:
            return { languageCode };
        default:
            return null;
    }
};

export default buildAutoCaptionOptions;
